var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-outline-primary",on:{"click":function($event){return _vm.triggerAction()}}},[_c('i',{staticClass:"fa fa-edit"})])}
var staticRenderFns = []

export { render, staticRenderFns }